export const LAST_MONTH = 'last-month';
export const LAST_WEEK = 'last-week';
export const LAST_THREE_MONTH = 'last-three-months';
export const LAST_SIX_MONTH = 'last-six-months';
export const ALL_TIME = 'all-time';
